// web/src/components/Skeleton.tsx — loading placeholders (animate-pulse, reduced-motion safe via CSS backstop).
export function Skeleton({ variant, count = 1 }: { variant: 'card' | 'row' | 'rail' | 'text'; count?: number }) {
  const base = 'animate-pulse rounded-lg bg-surface2/60';
  const h = variant === 'card' ? 'h-28' : variant === 'rail' ? 'h-12' : variant === 'row' ? 'h-14' : 'h-4';
  return (
    <div className="flex flex-col gap-3" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => <div key={i} className={`${base} ${h} w-full`} />)}
    </div>
  );
}
